/* eslint-disable react-hooks/exhaustive-deps */
import { BookingProvider, Signal } from '@common/constans';
import { IPnrInfo, IRequest } from '@common/models';
import { IReservationHistorySearchQuery } from '@common/models/ReservationHistorySearchQuery';
import CheckinLoginForm from '@components/checkIn/CheckinLoginForm';
import { IAppState } from '@misc/State';
import Abort from '@service/Abort';
import Config from '@service/Config';
import { Action, upcomingCheckin } from '@service/proxy';
import Translate from '@service/Translate';
import { FC, Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SkeletonCurrentTrips from './SkeletonCurrentTrips';
import UpComingCheckIn from './UpComingCheckIn';

const CheckinTabPanel: FC = () => {
    const { tr } = Translate;
    const [upComingCheckInLoadingVisibility, setUpComingCheckInLoadingVisibility] = useState<boolean>(false);
    const [upComingCheckInItems, setUpComingCheckInItems] = useState<IPnrInfo[]>([]);
    const { user } = useSelector((state: IAppState) => ({ user: state.user }));

    useEffect(() => {
        if (user.memberId)
            getUpcomingCheckInItems();
    }, [user]);

    const getUpcomingCheckInItems = () => {
        let skeletonTimeout: NodeJS.Timer;
        let request: IRequest<IReservationHistorySearchQuery> = {
            skip: 0,
            take: 2
        };
        skeletonTimeout = setTimeout(() => {
            setUpComingCheckInLoadingVisibility(true);
        }, 500);
        upcomingCheckin(Action.POST, { data: request, signal: Abort.get(Signal.History).signal })
            .then((response) => {
                setUpComingCheckInItems(response.content || []);
            })
            .catch(() => { })
            .finally(() => {
                clearTimeout(skeletonTimeout);
                setUpComingCheckInLoadingVisibility(false);
            })
    }

    return (
        <div className="check-in-tab-panel">
            <div className="check-in-tab-panel-upcoming-check-in">
                <h3 className='upcoming-check-in-title'>{tr("checkin")}</h3>
                {
                    Config.config.defaultBookingProvider === BookingProvider.Mahan && user.memberId ?
                        <Fragment>
                            {upComingCheckInLoadingVisibility ?
                                <SkeletonCurrentTrips />
                                :
                                <div className="upcoming-check-in-content">
                                    <UpComingCheckIn pnrInfo={upComingCheckInItems} />
                                </div>
                            }
                        </Fragment> : ""
                }
            </div>
            <CheckinLoginForm orientation="horizontal" />
        </div>
    )
}

export default CheckinTabPanel;